<script>
import TenantAdminRecipient from '@/tenant/components/TenantAdminRecipient.vue';
import AdminRecipientAddForm from '@/tenant/components/AdminRecipientAddForm.vue';

export default {
  components: {
    TenantAdminRecipient,
    AdminRecipientAddForm,
  },

  props: {
    recipients: { type: Array, required: true },
  },

  data: () => ({
    showAddForm: false,
  }),

}
</script>

<template>
  <b-card>

    <h4 class="mb-0 text-center"> Admin Recipients </h4>

    <div class="mt-3"></div>

    <div v-if="!recipients || recipients.length === 0" class="mb-3">
      You have no Admin recipients yet.
    </div>

    <b-list-group>
      <b-list-group-item v-for="recipient in recipients" :key="recipient.id">
        <tenant-admin-recipient
          :recipient="recipient"
          @deleted="$emit('updated', $event)" />
      </b-list-group-item>
    </b-list-group>

    <div class="mt-3"></div>

    <button
      v-if="!showAddForm"
      type="button"
      class="btn btn-outline-primary btn-block"
      @click="showAddForm=true">
      Add
    </button>
    <admin-recipient-add-form
      v-else
      @added="$emit('updated', $event); showAddForm=false"
      @cancel="showAddForm=false" />

  </b-card>
</template>



// WEBPACK FOOTER //
// src/tenant/components/TenantRecipientsCard.vue